import { GgEnvironment } from '@core/models/environment.interfaces';

export const environment: GgEnvironment = {
  production: false,
  env: 'development',
  apiUrl: 'https://dev-goomi.wlcmapps.com/api',
  stripeKey:
    'pk_test_51KsmLRHK4CLt7Dv1dI1SgA2O4vkFIldlSOjUd1pGr7sfyRb7AjPdZAn7HUp2PWJaDifLIQkue3BIyzgiyg9i2a5A00I4Rcf9UZ',
};
